import { field, date, children, lazy, writer, relation, json,text } from "@nozbe/watermelondb/decorators";
import { uuid } from "../../oscar-pos-core/constants";
import { sanitizeAttachments } from "../../constants";
import { Model, Q } from "@nozbe/watermelondb";
import {
  INVOICE_PAYMENTS_SCHEMA,
  INVOICE_SCHEMA,
  ORDERS_SCHEMA,
} from "../schema";

export default class Invoice extends Model {
  static table = INVOICE_SCHEMA;

  static associations = {
    signatures: { type: 'belongs_to', key: 'signatures_id' },
    customer: { type: "belongs_to", key: "customer_id" },
    business: { type: "belongs_to", key: "business_id" },
    company: { type: "belongs_to", key: "company_id" },
    invoice_payments: { type: "has_many", foreignKey: "invoice_id" },
    payment: { type: "has_many", foreignKey: "invoice_id" },
    orders: { type: "has_many", foreignKey: "invoice_id" },
  };

  @field("supplier_order_id") supplier_order_id;
  @field("transaction_id") transaction_id;
  @field("advance_amount") advance_amount;
  @text("invoice_prefix") invoice_prefix;
  @text("invoice_number") invoice_number;
  @text("invoice_title") invoice_title;
  @text("discount_unit") discount_unit;
  @field("sales_amount") sales_amount;
  @text("document_url") document_url;
  @field("cost_amount") cost_amount;
  @field("is_synced") is_synced;
  @text("recording") recording;
  @field("sub_total") sub_total;
  @text("image_url") image_url;
  @text("tax_title") tax_title;
  @text("signature") signature;
  @text("tranType") tranType;
  @text("category") category;
  @field("discount") discount;
  @field("tax_rate") tax_rate;
  @field("amount") amount;
  @text("status") status;
  @text("method") method;
  @text("wallet") wallet;
  @field("profit") profit;
  @field("total") total;
  @text("bank") bank;
  @text("note") note;
  @text("type") type;
  @text("reference_id") reference_id;
  @field("change_amount") change_amount;

  @date("transacted_at") transacted_at;
  @date("created_at") created_at;
  @date("due_date") due_date;

  @json("attachment", sanitizeAttachments) attachment;

  @relation('signatures', 'signatures_id') signatures;
  @relation("customer", "customer_id") customer;
  @relation("business", "business_id") business;
  @relation("company", "company_id") company;

  @children("invoice_payments") invoice_payments;
  @children("payment") payment;
  @children("orders") orders;


  @lazy getPayments = this.invoice_payments.extend(Q.experimentalSortBy("created_at", Q.desc));


  @writer async markAsDeleted() {
    await this.payment.destroyAllPermanently();
    await this.orders.destroyAllPermanently();
    await super.markAsDeleted();
  };

  @writer async maskAsPaid(method,date) {
    await this.update((invoice) => {
      invoice.status = "paid";
      invoice.transacted_at = date ? new Date(date) : new Date();
      invoice.method = method ? method : invoice.method
      invoice.advance_amount = invoice.amount
    });
  };

  @writer async updateInvoiceImage(url) {
    await this.update((invoice) => {
      invoice.image_url = url;
    });
  };

  @writer async updateInvocie(details) {
    await this.update((invoice) => {
      details.customer && invoice.customer.set(details.customer);
      details.company && invoice.company.set(details.company);
      invoice.recording = details?.recording_uri || null;
      invoice.advance_amount = details.advance_amount;
      invoice.invoice_number = details.invoice_number;
      invoice.invoice_prefix = details.invoice_prefix;
      invoice.invoice_title = details.invoice_title;
      invoice.discount_unit = details.discount_unit;
      invoice.sales_amount = details.sales_amount;
      invoice.document_url = details.document_url;
      invoice.cost_amount = details.cost_amount;
      invoice.attachment = details.attachment;
      invoice.sub_total = details.sub_total;
      invoice.signature = details.signature;
      invoice.tax_title = details.tax_title;
      invoice.image_url = details.image_url;
      invoice.transacted_at = details.date;
      invoice.due_date = details.due_date;
      invoice.category = details.category;
      invoice.discount = details.discount;
      invoice.tax_rate = details.tax_rate;
      invoice.amount = details.amount;
      invoice.method = details.method;
      invoice.wallet = details.wallet;
      invoice.profit = details.profit;
      invoice.status = details.status;
      invoice.total = details.total;
      invoice.note = details.note;
      invoice.bank = details.bank;
      invoice.reference_id = details.reference_id;

    });
  };

  @writer async updateInvoiceCustomer(customer) {
    await this.update((invoice) => {
      invoice.customer.set(customer);
    });
  };

  

  @writer async createOrder(details) {
    this.collections.get(ORDERS_SCHEMA).create((order) => {
      order.invoice.set(this);
      order.stock.set(details.model);
      order.selling_price = details.selling_price;
      order.cost_price = details.cost_price;
      order.quantity = details.quantity;
      order.name = details.name;
    });
  };

  @writer async updateInvoiceSignature(url) {
    await this.update((invoice) => {
      invoice.signature = url;
    });
  };

  @writer async createTransactionPayments(details) {
    this.collections.get(INVOICE_PAYMENTS_SCHEMA).create((payment) => {
      payment.business.set(this.business);
      payment.invoice.set(this);
      payment.wallet = details.wallet || "";
      payment.bank = details.bank || "";
      payment.method = details.method;
      payment.amount = details.amount;
      payment.created_at = new Date();
      payment._raw.id = uuid();
    });
  };

    @writer async updateInvoiceAttachments(attachment) {
        await this.update(invoice => {
            invoice.attachment = attachment;
        });
    };
       @writer async updateInvoiceCategory(category) {
        await this.update(invoice => {
            invoice.category = category;
        });
    };
}
